
<div id="device-details-component" class="component-inner-wrapper device-details-component-class">
  <main class="main-content">
      <div class="container">
          <div class="breadcrumb">
              <span class="ele_link" [routerLink]="['/device-list']">Device List</span>
              <span>></span>
              <span>Device Details</span>

          </div>
          <h1 class="page-title">Device Details : <span class="device-id-txt">{{gatewayId}}</span></h1>
          <div class="content-wrapper">
              <div class="device-details-wrapper">
                  <div class="details-sections-row">
                    <!-- Hardware Details -->
                    <div class="details-section">
                      <h5 class="section-heading fw-medium">Hardware</h5>
                      <p><strong>Type:</strong> {{ deviceDetailsData?.type || unavailable }}</p>
                      <p class="detail-row-flex">
                        <span class="detail-label sourced-field"
                              [matTooltip]="carrierProfileTooltip"
                              matTooltipShowDelay="200">
                          <strong>Carrier Profile:</strong>
                        </span>
                        <span class="detail-value sourced-field"
                              [matTooltip]="carrierProfileTooltip"
                              matTooltipShowDelay="200">{{ carrierProfileDisplay }}</span>
                      </p>
                      <p class="detail-row-flex">
                        <span class="detail-label"
                              [class.sourced-field]="!!physicalSimValueTooltip"
                              [matTooltip]="physicalSimValueTooltip"
                              matTooltipShowDelay="200">
                          <strong>Physical SIM:</strong>
                        </span>
                        <span class="detail-value"
                              [class.sourced-field]="!!physicalSimValueTooltip"
                              [matTooltip]="physicalSimValueTooltip"
                              matTooltipShowDelay="200">{{ physicalSimDisplay }}</span>
                      </p>
                      <p class="detail-row-flex">
                        <span class="detail-label sourced-field"
                              [matTooltip]="embeddedSimTooltip"
                              matTooltipShowDelay="200">
                          <strong>Embedded SIM:</strong>
                        </span>
                        <span class="detail-value sourced-field"
                              [matTooltip]="embeddedSimValueTooltip || embeddedSimTooltip"
                              matTooltipShowDelay="200">{{ embeddedSimDisplay }}</span>
                      </p>
                    </div>

                    <!-- Customer Details -->
                    <div class="details-section">
                      <h5 class="section-heading fw-medium">Customer Details</h5>
                      <p><strong>Asset ID: &nbsp;</strong>{{ deviceDetailsData?.assetId || unavailable }} </p>
                      <p><strong>Customer:</strong> {{ deviceDetailsData?.customer?.customerName || unavailable }}</p>
                      <p><strong>Asset: &nbsp;</strong>{{ deviceDetailsData?.assetName || unavailable }} </p>
                      <p><strong>Group:</strong> {{ deviceDetailsData?.otaGroup?.groupName || unavailable }}</p>
                    </div>

                    <!-- Current Configuration -->
                    <div class="details-section">
                      <h5 class="section-heading fw-medium">Current Configuration</h5>
                      <p class="detail-row-flex">
                        <span class="detail-label sourced-field"
                              [matTooltip]="configVersionTooltip"
                              matTooltipShowDelay="200">
                          <strong>Config Version:</strong>
                        </span>
                        <span class="detail-value sourced-field"
                              [matTooltip]="configVersionTooltip"
                              matTooltipShowDelay="200">{{ configVersionDisplay }}</span>
                      </p>
                      <p class="detail-row-flex">
                        <span class="detail-label sourced-field"
                              [matTooltip]="firmwareVersionTooltip"
                              matTooltipShowDelay="200">
                          <strong>Firmware Version:</strong>
                        </span>
                        <span class="detail-value sourced-field"
                              [matTooltip]="firmwareVersionTooltip"
                              matTooltipShowDelay="200">{{ firmwareVersionDisplay }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="tab-section row mt-4">
                    <div class="col-12" style="position: relative;">
                      <div class="d-flex justify-content-end exportButtonDiv">
                        <div class="grid-download-csv">
                          <div class="ms-auto">
                            <button class="button-download" (click)="exportComparison()" [disabled]="isLoading" title="Export comparison data between MongoDB and the Admin Tool for this device.">
                              <span class="button-icon" *ngIf="!isLoading"><mat-icon>cloud_download</mat-icon></span>
                              <span class="button-icon" *ngIf="isLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              </span>
                              <span class="button-text">{{ isLoading ? 'Exporting Comparison...' : 'Export Comparison' }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_Peripherals" label="Peripherals">
                        <app-peripherals-management></app-peripherals-management>
                        </mat-tab>
                        <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_DeviceHistory" label="Device History">
                          <app-device-history></app-device-history>
                        </mat-tab>
                        <!-- <mat-tab label="OTA History">
                          <app-ota-history></app-ota-history>
                        </mat-tab> -->
                        <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_DeviceConfigHistory" label="Device Config History">
                          <app-device-config-history></app-device-config-history>
                        </mat-tab>
                          <!-- <mat-tab label="Configuration">
                            <app-function-app></app-function-app>
                          </mat-tab> -->
                          <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_Engineering" label="Engineering">
                              <app-engineering></app-engineering>
                          </mat-tab>
                          <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_DeviceHealth" label="Device Health">
                            <ng-container *ngIf="gatewayId">
                              <app-device-health [gatewayId]="gatewayId"></app-device-health>
                            </ng-container>
                          </mat-tab>
                          <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_InstallerLog" label="Installer Log">
                            <ng-container *ngIf="gatewayId">
                              <app-installer-log-list [embeddedGatewayId]="gatewayId"></app-installer-log-list>
                            </ng-container>
                          </mat-tab>
                          <mat-tab *appHasPermission="RbacPermissions.DeviceDetails_SimDetails" label="SIM Details">
                            <ng-container *ngIf="gatewayId">
                              <app-sim-details
                                [gatewayId]="gatewayId"
                                [eid]="activeSimEid"
                              ></app-sim-details>
                            </ng-container>
                          </mat-tab>
                    </mat-tab-group>
                    
                    </div>
                  </div>
              </div>

          </div>

      </div>
  </main>
</div>



